<template>
  <div>
    system
  </div>
</template>

<script>
export default {
  components: {
  },

  data() {
    return {
    };
  },
  methods: {
  },
};
</script>



<style lang="scss" scoped>

</style>
